module.exports = __webpack_public_path__ + "media/images/landing/home/categories/concerts-1826d47c3a1001c2027a580fa4802469.png";